import { HTMLAttributes } from 'react';

export enum Theme {
    Dark = 'dark',
    Light = 'light',
    Grey = 'grey',
}

export interface TextProps extends HTMLAttributes<any> {
    theme?: Theme;
    tag?: TextTag;
    size?: TextSize;
    weight?: TextWeight;
    spacing?: TextSpacing;
    viewVariant?: 'centered';
    'data-test-id'?: string;
}

export enum TextTag {
    H1 = 'h1',
    H2 = 'h2',
    H3 = 'h3',
    H4 = 'h4',
    H5 = 'h5',
    H6 = 'h6',
    Span = 'span',
    P = 'p',
    Div = 'div',
}

export enum TextWeight {
    Regular = 'regular',
    Medium = 'medium',
    Semibold = 'semibold',
    Bold = 'bold',
    Heavy = 'heavy',
}

export enum TextSize {
    TitlePromo = 'title-promo',
    TitlePage = 'title-page',
    Superhead = 'superhead',
    TitleElevated = 'title-elevated',
    Title = 'title',
    Subtitle = 'subtitle',
    CaptionElevated = 'caption-elevated',
    Caption = 'caption',
    Body = 'body',
    BodyReduced = 'body-reduced',
    BodyLow = 'body-low',
    Note = 'note',
}

export enum TextSpacing {
    Default = 'default',
    Uppercase = 'uppercase',
    Headline = 'headline',
}
